import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const ExercicioIlegal = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const condicional = useSelector((state) => state.addForm.modulos)
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="IDENTIFICAÇÃO DA PESSOA NÃO HABILITADA A EXERCER ATIVIDADES PRIVATIVAS DA FISIOTERAPIA" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Nome" nome="pessoanaohabilitada" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="43vw" widthMobile="80vw" marginR="3vw" />
                        <Input label="RG" nome="rgilegal" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="15vw" widthMobile="80vw" marginR="3vw" />
                        <Input label="CPF" nome="cpfilegal" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="15vw" widthMobile="80vw" marginR="3vw" />
                        <Input label="Outros Dados" nome="dados" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="79vw" widthMobile="80vw" marginR="3vw" />
                        <Input label="Descrição da Situação Encontrada" nome="descricao" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="79vw" widthMobile="80vw" marginR="3vw" />
                    </div>


                    <HeaderVerde texto="LEGALIDADE" />
                    <div style={{ textAlign: "left" }}>
                    <Select label="Há Fisioterapeutas no Seviço Delegando Função (Lei Federal 6.316/1975 e Resolução COFITTO 424/13)" nome="delegfisio" modulo={modulo} index={n}
                           widthWeb="13vw" widthMobile="80vw" marginR="2vw"
                            array={["Sim", "Não"]} />
                        <Input label="Quantos Fisioterapeutas Delegando Função" nome="fisiolegalidade" modulo={modulo} index={n}
                           widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        {RenderQtdlegalidade()}
                    </div>
                </Caixa >

            )
            function RenderQtdlegalidade() {
                let campos = []
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                var quantidade = array[modulo][n]["fisiolegalidade"]
                if (array[modulo][n]["fisiolegalidade"]) {
                    for (let i = 0; i < quantidade; i++) {
                        campos.push(
                            <div>
                                <Input label="Nome" nome="nomelegalidade" modulo={modulo} index={n} subModulo="nomelegalidade" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="40vw" widthMobile="80vw" marginR="3vw" />
                               
                                <Input label="Crefito" nome="crefitolegalidade" modulo={modulo} index={n} subModulo="crefitolegalidade" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="14vw" widthMobile="80vw" marginR="3vw" />
                               
                                <Select label="Profissional" nome="utijornada" modulo={modulo} index={n} subModulo="utijornada" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="14vw" widthMobile="80vw" marginR="3vw"
                                    array={["Profissional RT", "Profissional Assistente"]} />

                            </div>
                        )
                    }
                }
                return campos
            }
        }
        return partes
    }
}

export default ExercicioIlegal